import { IonApp, IonButton, IonContent, IonIcon, IonSelect, IonSelectOption } from "@ionic/react";
import { pencil } from "ionicons/icons";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { calcScorePerUserForTournament, numberOfChooses } from "../../calcScore";
import Footer from "../../components/Footer";
import Bets from "../../components/Bets";
import Toolbar from "../../components/Toolbar";
import Firebase from "../../firebase";
import { URLS } from "../../urls";
import "./style.css";
import Avatar from "awesome-react-avataaars";

declare const document, window: any;

class User extends Component {
    state = {
        fb: Firebase.getInstance(),
        showBets: false,
        user: null as any,
        userBets: null as any,
        userData: {} as any,
        data: {} as any,
        tournamentID: "",
        avatar: {} as any,
    };

    _isMounted = true;

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        document.dispatchEvent(new Event("pageMount"));
        const userID: any = window.location.pathname.split("/")[2];
        const userData = await this.state.fb.readData("users/public/" + userID);
        var userBets = await this.state.fb.readData("users/bets/" + userID);
        const data = await this.state.fb.readData("data");
        console.log(userBets);

        var user = await this.state.fb.getUser();
        if ((user && userID === user.uid) || (await this.state.fb.isEditor()))
            this.setState({ showBets: true });
        else if (userData.scores) {
            console.log("enter!!!!!");

            userBets = {};
            for (let gameID in userData.scores) {
                userBets[gameID] = {
                    gameID,
                    choice: Array.from({ length: numberOfChooses(data) }, (x, i) => i),
                };
            }
        }
        await this.setState({
            user,
            userData,
            userBets,
            data,
            avatar: userData?.avatar ?? {},
        });
        var tournamentID = new URL(window.location).searchParams.get("tournamentID");
        if (!tournamentID)
            tournamentID = document.getElementsByClassName("user__selectTournamentOption")[0].value;
        document.getElementById("selectTournament").value = tournamentID;
    }

    render() {
        return (
            <IonApp>
                <Toolbar />
                <IonContent style={{ textAlign: "center" }}>
                    {this.state.showBets ? (
                        <Link to={URLS.ACCOUNT.url}>
                            <IonIcon icon={pencil} />
                        </Link>
                    ) : (
                        ""
                    )}
                    <h1 style={{ fontSize: "xx-large", display: "inline-block", paddingRight: "7px" }}>
                        {this.state.userData?.nickname}
                    </h1>
                    <br />
                    <Avatar
                        avatarStyle="Circle"
                        graphicType={this.state.avatar.graphicType}
                        topType={this.state.avatar.topType}
                        hatColor={this.state.avatar.hatColor}
                        accessoriesType={this.state.avatar.accessoriesType}
                        hairColor={this.state.avatar.hairColor}
                        facialHairType={this.state.avatar.facialHairType}
                        facialHairColor={this.state.avatar.facialHairColor}
                        clotheType={this.state.avatar.clotheType}
                        clotheColor={this.state.avatar.clotheColor}
                        eyeType={this.state.avatar.eyeType}
                        eyebrowType={this.state.avatar.eyebrowType}
                        mouthType={this.state.avatar.mouthType}
                        skinColor={this.state.avatar.skinColor}
                    />
                    <br />
                    <br />
                    <IonSelect
                        id="selectTournament"
                        placeholder="בחירת טורניר"
                        interface="popover"
                        className="myteam__selectGame"
                        onIonChange={(e: any) => {
                            this.setState({ tournamentID: e.detail.value });
                        }}
                    >
                        {this.state.data.Tournaments?.map((tournamentValue: any, tournamentIndex: any) => {
                            if (tournamentValue)
                                return (
                                    <IonSelectOption
                                        class="user__selectTournamentOption"
                                        value={tournamentValue.tournamentID}
                                        key={"tournament" + tournamentIndex}
                                    >
                                        {tournamentValue.tournamentDesc}
                                    </IonSelectOption>
                                );
                        })}
                    </IonSelect>
                    <br />
                    <div>
                        ניקוד מצטבר:{" "}
                        {calcScorePerUserForTournament(
                            this.state.data,
                            this.state.userData?.scores,
                            this.state.tournamentID
                        ) ?? 0}
                    </div>
                    <br />
                    <div>
                        <Link to={URLS.MY_TEAM.url + "?tournamentID=" + this.state.tournamentID}>
                            <IonButton style={{ display: "inline-block" }}>חילופים</IonButton>
                        </Link>
                    </div>
                    <br />
                    <Bets
                        data={this.state.data}
                        userBets={this.state.userBets}
                        userScores={this.state.userData?.scores}
                        tournamentID={this.state.tournamentID}
                        showPlayers={this.state.showBets}
                    />
                    <br />
                    <Footer />
                </IonContent>
            </IonApp>
        );
    }
}

export default User;
